import { useParams, useNavigate } from "react-router-dom";
import PortfolioDataList from "../../Data/PortfolioDataList";
import { PortfolioDetailedHeader } from "./PortfolioDetailedHeader";
import { ImageModel } from "./ImageModel";
import { PortfolioDiscription } from "./PortfolioDiscription";
import { ProjectSlider } from "./ProjectSlider";

const PortfolioDetailed = () => {
  const { id } = useParams();
  const navigate = useNavigate();



  const item = PortfolioDataList.find(
    (portfolio) => portfolio.id === parseInt(id, 10)
  );

  if (!item) {
    return (
      <div className="text-center">
        <h1 className="font-primary">Portfolio Item Not Found</h1>
        <button
          onClick={() => navigate("/portfolio-page")}
          className="mt-5 px-4 py-2 bg-blue-500 text-white rounded font-primary"
        >
          Go Back to Portfolio List
        </button>
      </div>
    );
  }

  return (
    <div className="portfolio-detailed  relative mt-10">
      <PortfolioDetailedHeader portfolioId={parseInt(id, 10)} />
      <div className="p-4 mt-8 md:p-16 ">
        <div className="flex flex-col gap-2 lg:flex-row md:justify-center min-[860px]:items-center lg:items-start lg:gap-12">
          <div className="flex-1">
            <ImageModel item={item} />
          </div>
          <div className="flex-1 min-[860px]:w-[730px] ">
            <PortfolioDiscription portfolioId={parseInt(id, 10)} />
          </div>
        </div>
        <div className="mt-8 min-[860px]:w-[730px] mx-auto lg:mx-0 lg:w-full">
          <ProjectSlider />
        </div>
      </div>
    </div>
  );
};

export default PortfolioDetailed;
